import { Inject, Injectable } from '@angular/core';
import { TInputAppEnvironmentVars } from '@monorepo/types';

export const SetPackEndPoints = {
  SAVE_SET_PACK: 'SAVE_SET_PACK',
  GET_SET_PACK_TRANSACTIONS: 'GET_SET_PACK_TRANSACTIONS',
  GET_SET_PACK_DASHBOARD_COUNT: 'GET_SET_PACK_DASHBOARD_COUNT',
  GET_SET_PACK_LISTING: 'GET_SET_PACK_LISTING',
  FERCH_PACK_BY_ID: 'FERCH_PACK_BY_ID',
  GET_PACK_AUDIT_LOGS: 'GET_PACK_AUDIT_LOGS',
  SET_PACK_EDIT_PACK_COUNT: 'SET_PACK_EDIT_PACK_COUNT',
  CREATE_SET_PACK: 'CREATE_SET_PACK',
  VALIDATE_SET_PACK: 'VALIDATE_SET_PACK',
  GET_TOTAL_WIP_QTY: 'GET_TOTAL_WIP_QTY',
  GET_BCTX_LIST_WITH_DESTINATION: 'GET_BCTX_LIST_WITH_DESTINATION',
};

type TSetPackEndPoints = typeof SetPackEndPoints;
type TSetPackEndPointsTypes = keyof TSetPackEndPoints;
type TEnvVariables = TSetPackEndPoints;

@Injectable({ providedIn: 'root' })
export class SetPackEnvProvider {
  private protocol = 'http';
  private service_host = '';

  private env_vars: TEnvVariables = {
    SAVE_SET_PACK: '',
    GET_SET_PACK_TRANSACTIONS: '',
    GET_SET_PACK_LISTING: '',
    FERCH_PACK_BY_ID: '',
    GET_SET_PACK_DASHBOARD_COUNT: '',
    GET_PACK_AUDIT_LOGS: '',
    SET_PACK_EDIT_PACK_COUNT: '',
    CREATE_SET_PACK: '',
    VALIDATE_SET_PACK: '',
    GET_TOTAL_WIP_QTY: '',
    GET_BCTX_LIST_WITH_DESTINATION: '',
  };

  constructor(@Inject('environment') ENV: TInputAppEnvironmentVars) {
    if (ENV.protocol !== null) {
      this.protocol = ENV.protocol;
    }
    if (ENV.service_host !== null) {
      this.service_host = ENV.service_host;
    }
    this.registerVars(ENV);
  }

  registerVars(environment: TInputAppEnvironmentVars) {
    const HOST_DOMAIN_WITH_PROTOCOL = this.protocol + this.service_host;
    this.env_vars.SAVE_SET_PACK = HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/set-pack/save';
    this.env_vars.GET_SET_PACK_TRANSACTIONS =
      HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/setPack/transactions/listing';
    this.env_vars.GET_SET_PACK_DASHBOARD_COUNT =
      HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/setPackDashboard/count';
    this.env_vars.GET_SET_PACK_LISTING =
      HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/setPack/listing';
    this.env_vars.FERCH_PACK_BY_ID =
      HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/setPack/fetchSetPackById';
    this.env_vars.GET_PACK_AUDIT_LOGS =
      HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/setPack/auditlog';
    this.env_vars.SET_PACK_EDIT_PACK_COUNT =
      HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/setPack/listing/editquantity';
    this.env_vars.CREATE_SET_PACK = HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/setPack/create';
    this.env_vars.VALIDATE_SET_PACK =
      HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/setPack/validatePackName';
    this.env_vars.GET_TOTAL_WIP_QTY =
      HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/packing/totalWip';
    this.env_vars.GET_BCTX_LIST_WITH_DESTINATION =
      HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/api/v1/order/item/byFactoryId/';
  }

  getEnvVar(key: TSetPackEndPointsTypes): string {
    return this.env_vars[key];
  }
}
